/* unplugin-vue-components disabled */import { render } from "./StyleSwitch.vue?vue&type=template&id=c594fa18"
import script from "./StyleSwitch.vue?vue&type=script&lang=js"
export * from "./StyleSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__